import { z } from 'zod'

export const eduInternSearchSchema = z.object({
  status: z.enum(['all', 'ongoing', 'upcoming', 'finished']).catch('ongoing'),
  search: z.string().max(200).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum(['lastname', 'group', 'pk', 'internship', 'hasOrg', 'start', 'end'])
    .catch('lastname'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type EduInternSearch = z.infer<typeof eduInternSearchSchema>

export const defaultEduInternSearch: EduInternSearch = {
  status: 'ongoing',
  page: 1,
  pageSize: 10,
  sortBy: 'lastname',
  direction: 'asc',
}
